import { render, staticRenderFns } from "./BeneficiaryList.vue?vue&type=template&id=3d6143f4&"
import script from "./BeneficiaryList.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports